import { useRef } from 'react';

/**
 * Waagerechtes Wischen für Reiter am Handy (Meine Events, 30.10.2026). Löst erst aus, wenn die
 * Bewegung deutlich waagerecht und mindestens 60px lang war, damit senkrechtes Scrollen nie
 * einen Reiterwechsel auslöst. Wischen, das in einem Eingabefeld beginnt, zählt nicht.
 */
export function useWischen(nachLinks: () => void, nachRechts: () => void) {
  const start = useRef<{ x: number; y: number } | null>(null);
  return {
    onTouchStart: (e: React.TouchEvent) => {
      const ziel = e.target as HTMLElement;
      if (e.touches.length !== 1 || ziel.closest('input, select, textarea, [data-kein-wischen]')) { start.current = null; return; }
      start.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    },
    onTouchEnd: (e: React.TouchEvent) => {
      const s = start.current;
      start.current = null;
      if (!s) return;
      const dx = e.changedTouches[0].clientX - s.x;
      const dy = e.changedTouches[0].clientY - s.y;
      if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.8) return;
      if (dx < 0) nachLinks(); else nachRechts();
    },
  };
}
